import React from "react";
import "./primarybutton.sass";
import { IButton } from "./PrimaryButton.types";
import { Variants } from "../../configs/configs.types";

export function PrimaryButton(props: IButton) {
  const onClickHandle = () => {
    props.onClick && props.onClick();
  };

  const variant = process.env.REACT_APP_VARIANT ?? Variants.v0;

  if (variant === "v0" || variant === "v5") {
    return (
      <button className="btn btn-primary" onClick={onClickHandle} id={props.id}>
        {props.text}
      </button>
    );
  }

  if (variant === "v1" && props.isSpecial) {
    return (
      <button className="btn btn-primary banner-btn" style={{width: "100%"}} onClick={onClickHandle} id={props.id}>
        {props.text}
      </button>
    );
  }

  return (
    <button className="btn btn-primary" onClick={onClickHandle} id={props.id}>
      <div className="btn-content">
        <span className="btn-text">{props.text}</span>
        <div>{props.children}</div>
      </div>
    </button>
  );
}
